<template>
  <div
    class="tw:w-full tw:px-4 tw:py-2 tw:flex tw:items-center tw:justify-center tw:gap-4 max-payment-bar-height tw:bg-yellow-500"
  >
    <div class="tw:flex tw:gap-1">
      <span class="tw:body-1--bold tw:line-clamp-2 tw:text-black">
        {{ trans._freemium.planReached.title }}
      </span>
      <span class="tw:body-1 tw:line-clamp-2 tw:text-black tw:hidden tw:sm:inline">
        {{ trans._freemium.planReached.subTitle }}
      </span>
    </div>

    <EdroneButton size="medium" @click="handleClick">
      {{ trans._freemium.planReached.button }}
    </EdroneButton>
  </div>
</template>

<script setup lang="ts">
import EdroneButton from "edrone-components/EdroneButton.vue";
import { symbolMachineFreemium } from "vue-app/components/Freemium/Freemium.machine";
import { inject } from "vue";

const actor = inject(symbolMachineFreemium);

const handleClick = () => {
  actor?.send({ type: "UPGRADE_PLAN" });
};
</script>
